import component from './CopyAgentId'

export default component
